import {qSelectObj} from '@/components/models';
import Notify from 'quasar/src/plugins/Notify.js';;

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $utils: Utils;
  }
}

class Utils {
  
  notify({icon = 'announcement', message = '', type = 'warning', timeout=2500}){
    Notify.create({
      message,
      icon,
      type,
      position: 'bottom-right',
      progress: true,
      timeout
    })
  }
  

  valEmail(email = ''){
    if(email
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )){
        return true;
      }
      return false;
  }
  
  valPhone(phone = ''){
    if(phone
      .toLowerCase()
      .match(
        /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
      )){
        return true;
      }
      return false;
  }

  valCedula(cedula = ''){
    if(cedula
      .toLowerCase()
      .match(
        /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{7}[\s.-]?\d{1}$/
      )){
        return true;
      }
      return false;
  }

  formatDate(d: string, s = ' - ', includeTime = false) {
    if (d) {
        // Crear objeto Date en UTC
        const date = new Date(d);
        
        // Obtener timestamp UTC y restar 4 horas (UTC-4)
        const utc4Date = new Date(date.getTime() - (4 * 60 * 60 * 1000));
        
        // Extraer componentes de fecha
        const day = String(utc4Date.getUTCDate()).padStart(2, '0');
        const month = String(utc4Date.getUTCMonth() + 1).padStart(2, '0');
        const year = utc4Date.getUTCFullYear();
        
        let formatted = day + s + month + s + year;
        
        // Agregar hora si se solicita
        if (includeTime) {
            let hours = utc4Date.getUTCHours();
            
            const minutes = String(utc4Date.getUTCMinutes()).padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';
            
            // Convertir a formato 12 horas
            hours = hours % 12;
            hours = hours ? hours : 12; // Si es 0, mostrar 12

            const hoursStr = String(hours).padStart(2, '0');
            
            formatted += ` ${hoursStr}:${minutes} ${ampm}`;
        }
        
        return formatted;
    }

    return '';
  }
  capitalize(st: string){
    if(!st) return;

    const splitted = st.split(' ');

    const s = splitted.reduce((pv, cv) => {
      return pv += ' ' + cv.charAt(0).toUpperCase() + cv.slice(1).toLowerCase();
    }, '')

    return s;

  }
  
  getLabels(data: qSelectObj[], limit = true){
    const d = [...data]
    return d.reduce((pv: string, cv: qSelectObj, index, arr) => {
      if(index == 3 && limit){
        arr.splice(3);
        return pv;
      }else{
        if(index == 2 && limit)
          return pv += cv.label+'... ';
        else if(index == d.length -1)
          return pv += cv.label;
          return pv += cv.label+', ';
      }
    }, '')
  }

  getPName(pId: string | number, data: qSelectObj[]){

    const found = data.filter(d => { return d.value == pId; });
    if(found.length > 0) return found[0].label;
     return 'Seleccione una provincia';

  }

}



const util = new Utils();


export { util };
